module.exports = __webpack_public_path__ + "static/media/tattoo.31b465ee.jpg";